export enum Action {
    Added = 'ADDED',
    Modified = 'MODIFIED',
    Removed = 'REMOVED',
}